<template>
  <div>
    <files type="handleContractFiles"></files>
  </div>
</template>

<script>
import files from './files.vue'
export default {
  components: { files },

  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped></style>